import {DealDasDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_ALL_DEAL_DAS';

export async function getAllDealDas(
    userToken: string,
    params: string,
    page: number
) {
    try {
        const result = await DealDasDao.getAllDealDas(userToken, params, page);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des domaines d\'activités des affaires',
            error: error
        });
    }
}
